<template>
  <el-aside
    id="aside"
    :width="'64px'"
    style="background-color: rgb(238, 241, 246)"
  >
    <el-menu :default-openeds="[]">
      <router-link to="/profile">
        <el-menu-item v-if="user && $auth.isAuthenticated">
          <el-avatar
            :size="'medium'"
            :src="user.picture"
            to="/profile"
          ></el-avatar></el-menu-item
      ></router-link>

      <router-link to="/">
        <el-menu-item> <i class="el-icon-s-home"></i> </el-menu-item>
      </router-link>

      <!-- <el-submenu index="1"> -->
      <!-- <template slot="title"> -->
      <!-- <span style="margin-left:6px;"> -->
      <!-- <i class="el-icon-s-tools"></i> -->
      <!-- </span> -->
      <!-- </template> -->
      <!-- <el-menu-item-group> -->
      <!-- <router-link to="/about">
        <el-menu-item>
          <i
            class="el-icon-info
"
          ></i> </el-menu-item
      ></router-link> -->

      <!-- <router-link to="/privacy">
        <el-menu-item>
          <i
            class="el-icon-question
"
          ></i> </el-menu-item
      ></router-link> -->

      <router-link index="2-2" to="/support">
        <el-menu-item> <i class="el-icon-service"></i> </el-menu-item
      ></router-link>

      <el-menu-item v-if="!$auth.isAuthenticated" @click="login">
        <i
          class="el-icon-lock
"
        ></i>
      </el-menu-item>

      <el-menu-item v-if="$auth.isAuthenticated" @click="logout">
        <i
          class="el-icon-unlock
"
        ></i
      ></el-menu-item>
      <!-- </el-menu-item-group>
      </el-submenu> -->
    </el-menu>
  </el-aside>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  methods: {
    login() {
      this.$auth.loginWithRedirect();
    },
    logout() {
      this.$auth.logout();
      this.$router.push({ path: "/" });
    },
    created() {}
  },
  async created() {}
};
</script>

<style>
#aside {
  height: 100vh;
}
a {
  text-decoration: none !important;
}

.el-avatar {
  margin-left: -5px;
}
</style>
